import React from "react";
import {
  Show,
  SimpleShowLayout,
  useResourceContext,
  useRecordContext,
  Tab,
  Datagrid,
  EditButton,
  TextField,
  ReferenceField,
  ReferenceManyField,
  DateField,
  TopToolbar,
  RefreshButton,
  ListButton,
  SelectField,
} from "react-admin";

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const ShowActions = () => {
  const resource = useResourceContext();
  const record = useRecordContext();
  return (
    <TopToolbar>
      <RefreshButton />
      <ListButton basePath={resource} />
      <EditButton basePath={resource} />
    </TopToolbar>
  );
};

const ShowTitle = () => {
  const record = useRecordContext();
  return record && <span>Sales Officer Show {record.name}</span>;
};

const SalesOfficersShow = ({ permissions, ...props }) => {
  return (
    <Show
      actions={<ShowActions permissions={permissions} />}
      {...props}
      title={<ShowTitle />}
    >
      <SimpleShowLayout className="so-show">
        <TextField label="Sales Officer Name" source="username" />
        <TextField label="Sales Officer Phone" source="phone" />
        <TextField label="Sales Officer Email" source="email" />
        <SelectField
          source="status"
          choices={[
            { id: true, name: "True" },
            { id: false, name: "False" },
          ]}
          defaultValue="status"
        />
        <SelectField
          label="Trade Developer Enabled"
          source="is_trade_developer"
          choices={[
            { id: true, name: "True" },
            { id: null, name: "-" },
            { id: false, name: "False" },
          ]}
          defaultValue="is_trade_developer"
        />
      </SimpleShowLayout>
    </Show>
  );
};

export default SalesOfficersShow;
